module.exports = __webpack_public_path__ + "img/symbol_9.d27842d5.png";